module.exports = __webpack_public_path__ + "img/Photo21.861f197e.jpg";